import AxiosConfig from "../../../axiosConfig";
import {getThumbnails } from 'video-metadata-thumbnails';
import {useParams} from "react-router-dom";
// import {getMetadata} from 'video-metadata-thumbnails';

const ipPrefix = String(process.env.REACT_APP_API_ENDPOINT).slice(0,process.env.REACT_APP_API_ENDPOINT.length-1);

export function getMediaArr() {
    let retArr = [];
    AxiosConfig
        .get("mediaManager/media/", {params: {belongs_in: 'A'}})
        .then((response) => {
            for (let i = 0; i < response.data.length; i++) {
                retArr[i] = ipPrefix + response.data[i].media;
            }
        });
    console.log(retArr);

    return retArr;
}

export function getMediaRes() {
    AxiosConfig
        .get("mediaManager/get_album/")
        .then((res) => {
            return res;
        })
}

export function getArray() {
    let arr = getMediaArr();
    console.log(arr.length)
    return arr;
}

export function getUserMedia(){
    let fileInfo = {
        typ :"",
        addr: ""
    };
    let retArr = [{}];
    AxiosConfig
        .get("mediaManager/get_album/",)
        .then((response) =>
        {
            for (let i = 0; i < response.data.length; i++) {
                fileInfo = {type: response.data[i].media_type,  addr: ipPrefix + response.data[i].media}
                retArr[i] = fileInfo;
            }
        });
    return retArr;
}
export function getMediaArrforCS(page) {
    const lI = [];
    AxiosConfig.get('mediaManager/media/?page='+page.toString()).then((res) => {
        for (let tm in res.data ) {
            if (res.data[tm].media_type === "I") {
                lI.push(ipPrefix + res.data[tm].media)
            } else if (res.data[tm].media_type === "V") {
                getThumbnails(ipPrefix + res.data[tm].media, {quality: 0.6, end: 2}).then((promiseO) => {
                    blobToBase64(promiseO[0].blob).then((blobToBase64r) => {
                        lI.push(blobToBase64r)
                    });
                });
            }
        }
    }).catch(e => {
        console.log(e);
    });
    return lI;
}
//From: https://stackoverflow.com/questions/18650168/convert-blob-to-base64
export function blobToBase64(blob) {
        return new Promise((resolve, _) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.readAsDataURL(blob);
        });
    }
export default getArray;
